









import { AreaChartComponent, AreaChartConfig, AreaChartData, Params } from '@empathy/insights';
import { DailyKeywordData } from '@empathybroker/tsclient-stats/dist/models/daily-keywords/daily-keyword-data';

import { KpiEnum } from '../../../enums';

export default {
  name: 'keyword-suggestion',
  props: {
    data: {
      type: Object, // KeywordData
      required: true
    }
  },
  computed: {
    chartParams: function (): Params<AreaChartConfig, AreaChartData> {
      return {
        config: {
          locale: this.$epb.locale,
          transitionsDurationInMillis: 0,
          areaOpacity: 1
        },
        data: [
          {
            name: KpiEnum.QUERIES,
            values: this.data.dist.map((distDataItem: DailyKeywordData) => ({
              name: distDataItem.date.toString(),
              value: distDataItem.queryCount
            }))
          }
        ]
      };
    }
  },
  data: function () {
    return {
      baseClass: 'epb-keyword-suggestion',
      chart: undefined
    };
  },
  created: function (): void {
    this.chart = new AreaChartComponent();
  },
  mounted: function (): void {
    this.chart.init(this.$refs.chart, this.chartParams);
  },
  beforeDestroy: function (): void {
    this.chart.destroy();
  },
  watch: {
    chartParams: {
      handler: function (params: Params<AreaChartConfig, AreaChartData>): void {
        this.chart.update(params);
      },
      deep: true
    }
  }
};

